import { styled } from "@creditas/stylitas"
import { Row as Root } from "react-grid-system"

import { marginHelper, paddingHelper } from "utilities"

export const Row = styled(Root)`
  ${marginHelper}
  ${paddingHelper}
`
